import React from "react";
import { cn } from "@jem-open/jem-ui";

interface SummaryTileProps {
  label: string;
  value: string;
  unit?: string;
  flag?: boolean;
}

const SummaryTile = ({
  label,
  value,
  unit,
  flag,
}: SummaryTileProps): JSX.Element => (
  <div
    className={cn(
      "rounded-lg border p-sm",
      flag ? "border-red-300 bg-red-50" : "border-greyscale-border bg-white"
    )}
  >
    <p className="text-xs uppercase tracking-wide text-greyscale-text-caption">
      {label}
    </p>
    <p
      className={cn(
        "text-xl sm:text-2xl font-semibold mt-xxxs",
        flag ? "text-red-700" : "text-greyscale-text-title"
      )}
    >
      {value}
    </p>
    {unit && <p className="text-xs text-greyscale-text-caption">{unit}</p>}
  </div>
);

export default SummaryTile;
